<mat-chip-listbox
  class="example-chip"
  cdkDropList
  cdkDropListOrientation="horizontal"
  >
  <mat-chip
    class="example-box"
    cdkDrag
    *ngFor="let entity of entityNames">
    {{entity}}
  </mat-chip>
</mat-chip-listbox>
